import { useTranslations } from 'next-intl';
import { GameCategoryRender } from '@/components/entities/games/GameCategoryRender/GameCategoryRender';
import EmptyStateVisual from '@/components/shared/EmptyStateVisual';
import { Button } from '@/components/ui/Button/button';
import { byAppVariant } from '@/consts/AppVariants';
import { useGroupCategories } from '@/hooks/useGroupCategories';
import { AppRoutes } from '@/i18n/constants';
import { Link } from '@/i18n/routing';
import { isStaging } from '@/libs/getEnvironment';
import emptyStateImageChristmas from '@/public/assets/image/global-states/empty/christmas/empty-christmas-state.webp';
import emptyStateImageBaseMobile from '@/public/assets/image/global-states/empty/default/empty-default-state-mobile.webp';
import emptyStateImageBase from '@/public/assets/image/global-states/empty/default/empty-default-state.webp';

export default function EmptyGamesState({ isSearch }: { isSearch: boolean }) {
  const t = useTranslations('game.favorites-games');
  const { beforeFavoritesCategories, afterFavoritesCategories } = useGroupCategories();
  const categoryIdByEnvironment = isStaging() ? '7f49c58a-5f65-4d25-84e3-aef4c67102f9' : '8614a166-259a-42a5-b028-38c979226615';
  const emptyStateImage = byAppVariant({
    christmas: emptyStateImageChristmas,
    default: emptyStateImageBase,
  });
  const emptyStateImageMobile = byAppVariant({
    christmas: emptyStateImageChristmas,
    default: emptyStateImageBaseMobile,
  });

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center text-center relative mt-4.75 lg:mt-2.5">
        <EmptyStateVisual
          mobileSrc={emptyStateImageMobile}
          desktopSrc={emptyStateImage}
          desktopImageClassName="mt-2.25"
        />

        <h2 className="text-white font-medium text-[1.25rem] leading-[130%] bottom-15 lg:bottom-20 mb-2.75">
          {isSearch
            ? t.rich('empty-state-search-title', {
                br: () => <br />,
              })
            : t('empty-state-title')}
        </h2>

        {!isSearch
          ? (
              <p className="font-regular text-sm leading-5 text-c300">{t('empty-state-title-description')}</p>
            )
          : null}

        <Button asChild className="py-3 max-lg:w-full max-w-90 mx-auto lg:px-[1.575rem] lg:py-4 mt-6.25">
          <Link href={AppRoutes.categoryIdPaged(categoryIdByEnvironment)}>
            {t('empty-state-description')}
          </Link>
        </Button>
      </div>

      <div className="w-full mt-10.25">
        {beforeFavoritesCategories?.map(category => (
          <GameCategoryRender
            key={category.id}
            categoryName={category.name}
            categoryId={category.id}
          />
        ))}
        {afterFavoritesCategories?.map(category => (
          <GameCategoryRender key={category.id} categoryName={category.name} categoryId={category.id} />
        ))}
      </div>
    </div>
  );
}
